import { MouseEvent as ReactMouseEvent, useLayoutEffect, useRef, useState } from 'react';

export const useDateTimePickerInput = (setDate: (date: Date) => void) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  useLayoutEffect(() => {
    if (open) {
      const handleClickOutside = (event: MouseEvent) => {
        if (event.target && !popupRef.current?.contains(event.target as Node)) {
          setOpen(false);
        }
      };

      document.addEventListener('click', handleClickOutside);

      return () => document.removeEventListener('click', handleClickOutside);
    }
    return () => {};
  }, [open, popupRef]);

  const handleSetDate = (newDate: Date) => {
    setDate(newDate);
    setOpen(false);
  };

  const handleMouseDown = (event: ReactMouseEvent) => {
    event.preventDefault();
    setOpen(true);
  };

  const handleReject = () => setOpen(false);

  return { open, handleMouseDown, handleSetDate, handleReject, popupRef };
};
